
import { Component, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import { CheckoutPaymentData } from './checkoutPayment.vue';
import Navigation from '@shared/components/navigation/navigation.vue';
import Container from '@shared/components/container/container.vue';
import CircleIcon from '@shared/components/container/circleIcon.vue';
import CheckoutPayWithVouchers from './checkoutPayWithVouchers.vue';
import CheckoutPaymentMethods from './checkoutPaymentMethods.vue';
import PubliCheck from '@shared/components/publiCheck/publiCheck.vue';
import LegalCheck from "@shared/components/legalCheck/legalCheck.vue";
import TriggerAnchor from '@shared/components/triggerAnchor/triggerAnchor.vue';
import CheckoutFooter from './checkoutFooter.vue';
import { Loader } from '@shared/core/helpers/loaderHelper';

@Component({
  components: {
    Navigation,
    CheckoutPayment,
    CheckoutPayWithVouchers,
    CheckoutPaymentMethods,
    CheckoutFooter,
    Container,
    CircleIcon,
    LegalCheck,
    PubliCheck,
    TriggerAnchor,
  },
})
export default class CheckoutPayment extends Vue {
  @Prop({ required: true }) private data!: CheckoutPaymentData|null;
  @Prop() private transport!: any;
  @Prop({ required: true }) private cid!: any;
  @Prop({ default: {promoCode: "", discount: 0, netDiscount: 0, discountedTaxes: 0} })
  private discountInfo!: {promoCode: string, discount: number, netDiscount: number, discountedTaxes: number};

  private acceptConditions: boolean = false;
  private okRss: boolean = false;
  private error: string|null = null;

  mounted() {
    this.okRss = this.data?.okRss ?? false;
    this.acceptConditions = this.data?.acceptConditions ?? false;
  }

  private async checkout(event: Event) {
    const checkoutSubmitBtn = event.target as Element;
    Loader.LoadingElement(checkoutSubmitBtn);
    await (this.$refs['paymentMethods'] as CheckoutPaymentMethods).checkout(false);
    Loader.UnloadingElement(checkoutSubmitBtn);
  }

  private scrollToFooter() {
    this.$nextTick(() => {
      const footerComponent = this.$refs.checkoutFooter as Vue;
      const footerEl = footerComponent?.$el as HTMLElement;
      if (footerEl && window.innerWidth < 500) {
        const rect = footerEl.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const offset = 100;
        const targetScroll = rect.top + scrollTop - offset;

        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
        });
      }
    });
  }
}
